import { render, staticRenderFns } from "./UberEatsBadge.vue?vue&type=template&id=3333d0d1&scoped=true&"
import script from "./UberEatsBadge.vue?vue&type=script&lang=js&"
export * from "./UberEatsBadge.vue?vue&type=script&lang=js&"
import style0 from "./UberEatsBadge.vue?vue&type=style&index=0&id=3333d0d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3333d0d1",
  null
  
)

export default component.exports